import React from "react";

const HeadingOne = props => {
  return <div className="heading1">{props.text}</div>;
};

export default HeadingOne;
